module.exports = __webpack_public_path__ + "static/media/create_funnel_sample_mobile_en.a33e3aec.png";